module.exports = __webpack_public_path__ + "img/file.8ce67ef1.svg";